import { useState } from "react";
import { LiveTableProps } from "../../../../types";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";
import { Button, TableContainerAnticipation } from "../../../../styles";
import Table, { TableColumn } from "../../../../../../components/Table";
import { formatMoney } from "../../../../../../utils/generalFormat";
import { EyeOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import useGetMe from "../../../../../../hooks/useCurrentUser";

export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange = () => {},
}) => {
  const history = useHistory();
  const [isLoading] = useState(false);
  const formattedDate = (date: string) => formatDateView(date);
  const user = useGetMe();

  const formatDateView = (dateString: any) => {
    const date = new Date(dateString);

    // Pad single digits with leading zero
    // @ts-ignore
    const pad = (num) => (num < 10 ? `0${num}` : num);

    const formattedDate = `${pad(date.getUTCDate())}/${pad(
      date.getUTCMonth() + 1
    )}/${date.getUTCFullYear()}`;

    return formattedDate;
  };

  return (
    <div>
      <LoadingOverlay show={isLoading} relative />
      <TableContainerAnticipation>
        <Table
          dataSource={data.records}
          pagination={{
            defaultPageSize: pageSize,
            defaultCurrent: currentPage,
            current: currentPage,
            onShowSizeChange: (_, size) => {
              onPageSizeChange(size);
            },
            total: data.count,
            onChange: (pageNum) => onPageChange(pageNum),
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} antecipações`,
          }}
        >
          <TableColumn
            title="Codigo do lojista"
            dataIndex="merchantId"
            key="merchantId"
          />
          <TableColumn
            title="Total Líquido"
            dataIndex="originalTotalLiquid"
            key="originalTotalLiquid"
            render={formatMoney}
          />
          <TableColumn
            title="Novo Total Líquido"
            dataIndex="newTotalLiquid"
            key="newTotalLiquid"
            render={formatMoney}
          />
          {user.userType === 3 && (
            <TableColumn
              title="Receita Total"
              dataIndex="totalRevenue"
              key="totalRevenue"
              render={formatMoney}
            />
          )}

          <TableColumn
            title="Nova Data Recebimento"
            dataIndex="newReceiveDate"
            key="newReceiveDate"
            render={formattedDate}
          />
          <TableColumn
            title="Quantidade de Transações"
            dataIndex="countTransactions"
            key="countTransactions"
          />

          <TableColumn
            title="Total Dias Antecipado"
            dataIndex="totalAnticipatedDays"
            key="totalAnticipatedDays"
          />

          <TableColumn
            title="Tempo Médio"
            dataIndex="averageTime"
            key="averageTime"
          />

          {user.userType === 3 && (
            <TableColumn
              title="Taxa Fator de Aquisição"
              dataIndex="purchasingFactorFee"
              key="purchasingFactorFee"
            />
          )}

          {user.userType === 3 && (
            <TableColumn
              title="Taxa Ad Valorem"
              dataIndex="adValoremFee"
              key="adValoremFee"
            />
          )}

          {user.userType === 3 && (
            <TableColumn
              title="Taxa Diária de IOF"
              dataIndex="dailyIofFee"
              key="dailyIofFee"
            />
          )}

          {user.userType === 3 && (
            <TableColumn
              title="Taxa Adicional de IOF"
              dataIndex="additionalIofFee"
              key="additionalIofFee"
            />
          )}

          {user.userType === 3 && (
            <TableColumn
              title="Taxa Total de Tarifas"
              dataIndex="totalTariffFee"
              key="totalTariffFee"
            />
          )}

          {user.userType === 3 && (
            <TableColumn
              title="Taxa de Recompra"
              dataIndex="rebuyFee"
              key="rebuyFee"
            />
          )}

          {user.userType === 3 && (
            <TableColumn
              title="Outras Taxas"
              dataIndex="othersFee"
              key="othersFee"
            />
          )}

          <TableColumn
            title="Valor Fator de Compra"
            dataIndex="purchasingFactorValue"
            key="purchasingFactorValue"
            render={formatMoney}
          />
          <TableColumn
            title="Valor Ad Valorem"
            dataIndex="adValoremValue"
            key="adValoremValue"
            render={formatMoney}
          />
          <TableColumn
            title="Impostos"
            dataIndex="totalIofValue"
            key="totalIofValue"
            render={formatMoney}
          />
          <TableColumn
            title="Valor Total de Tarifas"
            render={formatMoney}
            dataIndex="totalTariffValue"
            key="totalTariffValue"
          />
          <TableColumn
            title="Valor Total de Recompra"
            render={formatMoney}
            dataIndex="totalRebuyValue"
            key="totalRebuyValue"
          />
          <TableColumn
            title="Valor Total de Outras Taxas"
            render={formatMoney}
            dataIndex="TotalOthersValue"
            key="TotalOthersValue"
          />
          <TableColumn
            title="Data da Antecipação"
            dataIndex="anticipationDate"
            key="anticipationDate"
            render={(value: string) =>
              value && !isNaN(Date.parse(value))
                ? new Date(value.replace(" ", "T")).toLocaleDateString("pt-BR")
                : ""
            }
          />
          <TableColumn
            title="Visualizar"
            key="visualizar"
            render={(_: any, record: any) => (
              <EyeOutlined
                style={{ cursor: "pointer", fontSize: 18 }}
                onClick={() => {
                  const id = record.id;
                  if (id) {
                    history.push(`/transacao-historico-antecipacao/${id}`);
                  } else {
                    console.warn("ID não encontrado:", record);
                  }
                }}
              />
            )}
          />
        </Table>
      </TableContainerAnticipation>
    </div>
  );
};
export default LiveTable;
